module.exports = __webpack_public_path__ + "static/media/screenshot-intellicover.b4908d07.jpg";